import { render, staticRenderFns } from "./TheAccordionItem.vue?vue&type=template&id=5e56d498&scoped=true"
import script from "./TheAccordionItem.vue?vue&type=script&lang=js"
export * from "./TheAccordionItem.vue?vue&type=script&lang=js"
import style0 from "./TheAccordionItem.vue?vue&type=style&index=0&id=5e56d498&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e56d498",
  null
  
)

export default component.exports